import { render, staticRenderFns } from "./upload-idCard.vue?vue&type=template&id=18e79d7c&scoped=true"
import script from "./upload-idCard.vue?vue&type=script&lang=js"
export * from "./upload-idCard.vue?vue&type=script&lang=js"
import style0 from "./upload-idCard.vue?vue&type=style&index=0&id=18e79d7c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e79d7c",
  null
  
)

export default component.exports